import {
  RazorInputField,
  RazorModal,
} from "../../../../../components/razor-reuse";
import { useEffect, useRef, useState } from "react";
import { myComponentProps } from "./EndSessionModal";
import { useDispatch, useSelector } from "react-redux";
import { disabled2FA } from "../../../../../redux/settings";
import { getLoggedInUser } from "../../../../../redux/userAuth";
import RootState from "../../../../../redux/type";

export default function DisableMFAOtp({ visible, onClose }: myComponentProps) {
  const pinRef = useRef();
  const dispatch = useDispatch();
  const { loading_mfa } = useSelector((state: RootState) => state.settings);
  const [completeToken, setCompleteToken] = useState<boolean>(false);
  const [details, setDetails] = useState({
    otp: "",
  });

  // Clear modal input on modal visible
  useEffect(() => {
    if (visible) {
      setDetails((prev) => {
        return { ...prev, otp: "" };
      });
    }
  }, [visible]);

  // Function to verify otp
  const verifyOtpFunc = async () => {
    const payload = {
      secret: details.otp,
    };
    const data = await dispatch(disabled2FA(payload) as any);
    if (data?.payload?.data?.status) {
      handleClose();
      dispatch(getLoggedInUser({}) as any);
    }
  };

  // handle modal close
  const handleClose = () => {
    setDetails((prev) => {
      return { ...prev, otp: "" };
    });
    //@ts-ignore
    pinRef?.current?.forEach((input: any) => (input.value = ""));
    onClose && onClose();
    setCompleteToken(false);
  };

  return (
    <RazorModal visible={visible} onClose={handleClose} onBtnClick={() => {}}>
      <div className="disabled-mfa-modal-wrap">
        {/* title start */}
        <h4 className="header">2FA Authentication</h4>
        <p className="desc">Enter your code to access your account</p>
        {/* title end */}
        <div className="input-form-wrap">
          <RazorInputField
            pinRef={pinRef as any}
            color="black-light"
            type="pin"
            pinFieldNumber={6}
            value={details?.otp}
            onChange={(param: any) => {
              setDetails((prev) => {
                return { ...prev, otp: param };
              });
              setCompleteToken(false);
            }}
            onComplete={() => {
              setCompleteToken(true);
            }}
            // key={otpKey as any}
          />
        </div>
        <RazorInputField
          color={`black-light`}
          value="Proceed"
          type="submit"
          onSubmit={verifyOtpFunc}
          className="btn"
          disabled={!completeToken || loading_mfa}
          loading={loading_mfa}
        />
      </div>
    </RazorModal>
  );
}
